import { testArrayContainsValue, testIsNonEmptyString } from '../../lib/test-and-assert/test-base';
import { LIMITS } from './limits';

/**
 * @param {String} limit
 */
function testIsLimit(limit) {
    if (!testIsNonEmptyString(limit)) {
        return false;
    }

    return testArrayContainsValue(LIMITS, limit);
}

export { testIsLimit };
